import {
  MutationForgotPasswordArgs,
  MutationUpdatePasswordWithTokenArgs,
} from '@wm-front/client/graphql'
import { LoginMutationVariables } from '../graphql'
import { UpdatePasswordParams } from '../data/interfaces'

export class SetToken {
  public static readonly type = '[Auth] Set Token'

  constructor(
    /** JWT token */
    public token: string,
    /** Authentication mode */
    public mode: 'clerk' | 'legacy' = 'legacy'
  ) {}
}

export class Login {
  public static readonly type = '[Auth] Set login'

  constructor(public payload: LoginMutationVariables) {}
}

export class LoginFromStorage {
  public static readonly type = '[Auth]  Login from storage'
}

export class Logout {
  public static readonly type = '[Auth] Logout'
}

export class ForgotPassword {
  public static readonly type = '[Auth] Forgot Password'

  constructor(public payload: MutationForgotPasswordArgs) {}
}

export class FetchUserInfos {
  public static readonly type = '[Auth] Fetch User Infos'
}

export class UpdatePasswordWithToken {
  public static readonly type = '[Auth] Update Password With Token'

  constructor(public payload: MutationUpdatePasswordWithTokenArgs) {}
}

export class UpdatePassword {
  public static readonly type = '[Auth] Update Password'

  constructor(public payload: UpdatePasswordParams) {}
}
